import { MuzeumPage } from './../pages/muzeum/muzeum';

import { ExhibitionPage } from './../pages/exhibition/exhibition';
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, NavParams } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import {DataProvider} from '../providers/data/data';
import { MenuController } from 'ionic-angular';

import { Http, Response } from '@angular/http';

import { SpotPage } from './../pages/spot/spot';


import { HomePage } from '../pages/home/home';
import { WelcomePage } from 'src/pages/welcome/welcome';

import { ModalController } from 'ionic-angular';
import { NumpadComponent } from './../components/numpad/numpad';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  
  @ViewChild(Nav) navCtrl: Nav;
  // @ViewChild(NavParams)  navparams: NavParams;


  
    rootPage:any;
    mdoalvoaopen=false;
    homePage="home";
    lang;
    nameName="";
    phoneName=""
    muzeum;
    sendContactFLAG = false;
  constructor(public _http:Http,public menuCtrl: MenuController,
    platform: Platform,  statusBar: StatusBar, splashScreen: SplashScreen,
    private _DataProvider:DataProvider
    ,private _ModalController:ModalController) {
    platform.ready().then(() => {
 

      
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      var userwork =this._DataProvider.getLocalStorage('userwork');
      if(!userwork){
        this._DataProvider.setLocalStorage("userwork",'_' + Math.random().toString(36).substr(2, 9))
      }

      this._DataProvider.lang=this._DataProvider.getLocalStorage('lang');
      var urlCode = this._DataProvider.getLocalStorage('muzeum');

      // var urlCode2 = this.navparams.get('urlCode');



      if( urlCode ){


  
        this._DataProvider.getMuzeumByurlCodeFB(urlCode).subscribe((res:any) => {
          if(res.length != 0){
            this._DataProvider.Muzeum = res[0];
          } });
          }else{    


            }


      statusBar.styleDefault();
      splashScreen.hide();
    });
  }




  check_Page_Numpad(){
    // console.log('currentPage',this._DataProvider.currentPage)
    if(
    this._DataProvider.currentPage != 'app' 
    && 
    this._DataProvider.currentPage != 'home' 
    && 
    this._DataProvider.currentPage != '' 
    &&
    this._DataProvider.currentPage != 'welcome' 
    ){
      return true;
    }else{
      return false;
    }
  }



   showNumPad(){
    const modal = this._ModalController.create(ExhibitionPage);
    modal.present();
  }


  async show_new_sale_modal(){

  }


  ngOnInit(){
  // console.log(this._DataProvider.Muzeum.code);
  this._DataProvider.currentPage = 'app'

    // this._DataProvider.fbTest('val').subscribe((res:any) => {
    //   console.log("res",res);
    // });
      // Handle route change

  
     

      // let onetime = true;
      this._DataProvider.navToSpot.subscribe(item=>{
      if(item.id != '' && this._DataProvider.currentPage != 'home' ){
        
        console.log('navToSpot',item)
  
          console.log(item);
          this._DataProvider.selectedSpotExe = item.id;
          console.log(this._DataProvider.selectedSpotExe);
          console.log(this.muzeum);
          this._DataProvider.setLocalStorage('selectedSpotID', item.id);
          this.navCtrl.push(SpotPage, item)
          // onetime = false; 
  
          // navToSpot.unsubscribe();
          this._DataProvider.navToSpot.next({id:'',muzeum:'',exhibition:''})
        }
      })

    
    console.log('ebter????');
    if(this._DataProvider.ExhibitionsService){

    }else{
  //    this._DataProvider.ExhibitionsService = this._DataProvider.getLocalStorage('muzeum');
    }
    
console.log("this._DataProvider.Muzeum",this._DataProvider.ExhibitionsService);
  }
  enterExhibition(select){
    console.log(select,this._DataProvider.Muzeum.urlCode,select._id,"select");
    this._DataProvider.setLocalStorage('exhibitionID',select._id);

    this._DataProvider.selectedExebition = select;
    this.navCtrl.push(ExhibitionPage, {
      muzeum:this._DataProvider.Muzeum.urlCode,
      id:select._id,
    })

  }

  modalVoa(){
    this.menuCtrl.close();

       this._DataProvider.mdoalvoaopen=true;

     }
     
     closeModal(){
       console.log("closemodal")
       this._DataProvider.mdoalvoaopen=false;
     }
     sendData(){
      
      const url = 'https://api.irail.be/';

      this._http.post('https://webc.co.il/voaMail/',{name: this.nameName,phone: this.phoneName }).subscribe(respone=>{
        console.log('respone: ',respone);
        this.sendContactFLAG = true;
      }); 

     }

  goToHome(params){
    console.log("gohome");
    if (!params) params = {};
    this.navCtrl.setRoot(HomePage, {
      muzeum:this._DataProvider.Muzeum.urlCode,
    });
  }
  goToMuzeum(params){
    if (!params) params = {};
    this.navCtrl.setRoot(MuzeumPage);
  }
  
  goToMuz(){
    
    console.log('lang1111111',this._DataProvider.NowLang,MuzeumPage);
    this.navCtrl.setRoot(MuzeumPage, {
      muzeum:this._DataProvider.Muzeum.urlCode,
    })
    
  }

 

  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts